import { viewer } from '../../utils/launchViewer'
import ModalAddBimlinkTipo from './ModalAddBimlink/ModalAddBimlinkTipo'
import { useState } from 'react'
import { AddBimLinkToTipoProvider } from 'context/AddBimLinkToTipoContext'
import AddIcon from '@mui/icons-material/Add'


import { areSameExternalIds } from 'utils/handleTipos'
import BadgeCell from './BadgeCell'
import ButtonsCell from './ButtonsCell'
import ModalUpdateTipoBimlink from './ModalUpdateTipoBimLink/ModalUpdateTipoBimlink'
import { useUpdateTipoBimLink } from 'lib/react-query/queriesTipoBimLinkProyectos'
import { useNavigate } from 'react-router-dom'

function TipoRow({ t }) {
  const navigate = useNavigate()
  const { lmvId: dbId, name, revitCategory, tipoBimlink, items } = t

  const parentsDbIds = items.map(item => item.svf2Id) || []
  const externalIds = items.map(item => item.externalId) || []
  const areSame = !tipoBimlink
    ? true
    : areSameExternalIds(externalIds, tipoBimlink.tipoExternalId)
  const mutationUpdateTipo = useUpdateTipoBimLink()
  const { bimlink: { code } = {} } = tipoBimlink || {}
  const [isModalOpened, setIsModalOpened] = useState(false)
  const [isModalUpdateTipoOpened, setIsModalUpdateTipoOpened] = useState(false)

  const handleClick = () => {
    viewer.isolate(parentsDbIds)
    viewer.fitToView(parentsDbIds)
  }

  const openModalUpdateTipo = () => {
    setIsModalUpdateTipoOpened(true)
  }

  const updateTipo = () => {
    mutationUpdateTipo.mutate({
      id: tipoBimlink._id,
      body: {
        tipoExternalId: externalIds,
      },
    })
    setIsModalUpdateTipoOpened(false)
  }

  const handleAdd = () => {
    setIsModalOpened(true)
  }

  const buttonsArray = [
    {
      name: 'Vincular bimlink',
      Icon: <AddIcon />,
      onClick: handleAdd,
      class: 'add-bimlink-to-tipo',
    },
  ]

  if (tipoBimlink && !tipoBimlink.visible) return null

  return (
    <tr>
      {isModalOpened && (
        <AddBimLinkToTipoProvider
          tipo={{ ...tipoBimlink, name: name, externalIds }}
        >
          <ModalAddBimlinkTipo
            handleOnClose={() => setIsModalOpened(false)}
            tipo={t}
          />
        </AddBimLinkToTipoProvider>
      )}
      {isModalUpdateTipoOpened && (
        <ModalUpdateTipoBimlink
          handleOnClose={() => setIsModalUpdateTipoOpened(false)}
          handleOnClick={updateTipo}
        />
      )}
      <td className='table-row-bigger' onClick={handleClick}>{name}</td>
      <td className='table-row-bigger'>{revitCategory}</td>

      <td className="container-buttons-row-articulo">
        {!tipoBimlink || !tipoBimlink.bimlink ? (
          <ButtonsCell buttonsArray={buttonsArray} />
        ) : (
          <BadgeCell
            code={code}
            areSame={areSame}
            classnames="badge--pointer"
            onClick={() =>
              navigate(`edit-bimlink/${tipoBimlink?.bimlink?._id}`)
            }
            onClickNotSame={openModalUpdateTipo}
            tooltipText="Editar bimlink"
          />
        )}
      </td>
    </tr>
  )
}

export default TipoRow
